<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-container class="bgcolor">
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-text>
                            <v-card-title class="text-h5">お知らせ（新着）</v-card-title>
                            <div class="text--primary">
                            <ul id="example-1">
                              <li v-for="item in items">
                                {{ item.created_at | moment }} {{ options[item.type].type }} {{ item.title }} 
                              </li>
                            </ul>
                            </div>
                            <v-card-actions class="text-right">
                                <v-col>
                                    <v-list-item link href="/documents/notifications">
                                        <v-btn color="blue" class="white--text" >すべて見る</v-btn>
                                    </v-list-item>
                                </v-col>
                            </v-card-actions>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-card>
                        <v-card-text>
                            <v-card-title class="text-h4">
                                送信件数
                            </v-card-title>
                            <v-row>
                                <v-col>
                                    <dashboard-send-count-component
                                        :month_name="this_month_name"
                                        :plan_name="this_month_plan_name"
                                        :plan_identifier="this_month_plan_identifier"
                                        :send_count_list="this_month_send_count"
                                    ></dashboard-send-count-component>
                                </v-col>
                                <v-col>
                                    <dashboard-send-count-component
                                        :month_name="last_month_name"
                                        :plan_name="last_month_plan_name"
                                        :plan_identifier="last_month_plan_identifier"
                                        :send_count_list="last_month_send_count"
                                    ></dashboard-send-count-component>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        props: {
            items: Array,
            this_month_send_count: Object,
            last_month_send_count: Object,
            this_month_plan_name: String,
            last_month_plan_name: String,
            this_month_plan_identifier: String,
            last_month_plan_identifier: String,
            flashMessages: {
                type: Object,
                default: {
                    text: '',
                    success: true,
                },
                required: false,
            },
        },
        data() {
            return {
                options : [
                    { id: 0, type: '契約関連' },
                    { id: 1, type: '企業(メンバー)関連' },
                    { id: 2, type: 'システム関連' },
                ],
                message: {
                    success: false,
                    text: '',
                },
                this_month_name: '今月',
                last_month_name: '先月'
          };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '' && this.message.text != null;
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        mounted() {
            if (this.flashMessages.text != '' && this.flashMessages.text != null ) {
                this.message.text = this.flashMessages.text;
                this.message.success = this.flashMessages.success;
            }
            let params = new URLSearchParams(window.location.search);
            if (params.has("count") == true) {
                let count = parseInt(params.get("count"));
                let maxCount = 2;
                if(count > 0 && count <= maxCount){
                    let location = "/documents/dashboard?count=" + (count + 1);
                    if(count == maxCount){
                        location = "/documents/dashboard";
                    }
                    setTimeout(function(){
                        window.location = location;
                    }, 5000);
                }
            }
        },
        // 日付フォーマット
        filters: {
            moment(date) {
                return moment(date).format('YYYY/MM/DD');
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '../../../sass/app.scss';
    .notice-icon {
        margin-right: 10px !important;
    }
    
    .text--primary {
        font-size: 1.92rem !important;
        line-height: 3rem;
    }
    
    .main-container {
        font-family: $body-font-family;
        font-size: $font-size-root;
    }

    .main-content-area {
        margin-top: 10px;
    }

    .bgcolor{
        background-color: #E7F9F7;
    }
    
    .v-card {
        background-color: #F4FEFB;
        max-width: 1000px;
    }
</style>